import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Redirect, Route } from 'react-router-dom';
import { Provider } from 'mobx-react';

import './style/index.less';
import * as Lib from './lib';
import reportWebVitals from './reportWebVitals';
import { getLocale, weappSDK, setTitle, getLabel, regOvProps } from "@weapp/utils";
import { MDialog, CorsComponent } from "@weapp/ui";
import { clearOneCookie, getBrowserLangType, getCookie, getQueryString, inApp, inPCClient, isMobile, setCookie, setMainHostCookie } from "./utils";
import { publicUrl } from "./constants";
const { toast } = MDialog;
const {
  pcStores,
  mStores,
  commonStores,
  RouteLoginPool,
  MLoginPool,
  Loading } = Lib;

const stores = {
  ...commonStores,
  ...pcStores,
  ...mStores
}

// 从官网注册来
if (getQueryString('registerLang')) {
  let domain = window.location.hostname;
  if (domain.indexOf('passport') !== -1) {
    domain = domain.replace('passport', '');
  }
  setCookie('langType', getQueryString('registerLang'), domain);
}

setMainHostCookie('E10_moduleSource', '');
if (!getCookie('langType')) {//针对特殊浏览器语言处理
  const browserLanguage = window.navigator?.language || (window?.navigator as any)?.browserLanguage;
  let langType = getBrowserLangType(browserLanguage);
  if (langType) {
    let domain = window.location.hostname;
    if (domain.indexOf('passport') !== -1) {
      domain = domain.replace('passport', '');
    }
    setCookie("langType", langType, domain);
    if (!inApp()) {
      window.sessionStorage.setItem('PASSPORT_LANGTYPE_CHANGED', '1');
    }
  }
}

// if (localStorage.getItem('ppppppp')) {
//   regOvProps('weappPassportWeb', 'Login', (props) => {
//     return {
//       ...props,
//       accountConfig: {
//         type: "checkbox", //默认menu
//         list: ["account", "password", "autoLogin"]  //默认都显示
//       }
//     }
//   })

// }


// if (inApp() && isMobile() && !getCookie('langType')) {

//   let langType = getQueryString('langType');
//   let domain = window.location.hostname;
//   if (domain.indexOf('passport') !== -1) {
//     domain = domain.replace('passport', '');
//   }
//   if (langType) {
//     setCookie("langType", langType, domain);
//   }
// }
window.__ET_WEB_FLAG = true;

try {
  window.opener = null
} catch (error) {

}

const initPage = () => {
  getLocale('@weapp/passport').then((locale) => {
    if (inPCClient()) {//pc客户端国际化传递
      try {
        weappSDK.ready(() => {
          if (weappSDK.customSDK.checkJsApi('getLangLabels')) {
            weappSDK.customSDK.invoke("getLangLabels", {
              success: (res: any) => {
                const labelObj = {} as any;
                (res?.langKeys || []).forEach((labelId: any) => {
                  labelObj[labelId] = (locale?.labels || {})[labelId]
                })
                if (res?.langKeys?.length && weappSDK.customSDK.checkJsApi('setLangLabelInfo')) {
                  weappSDK.customSDK.invoke("setLangLabelInfo", {
                    localInfo: { type: getCookie('langType'), label: labelObj },
                    success: (respons: any) => {
                      console.log(respons)
                    }
                  })
                }
              }
            })
          }
        })

      } catch (error) {
        console.log(error)
      }
    }
    ReactDOM.render(
      <React.StrictMode weId={`_jzybwa`}>
        <Provider weId={`_1n4xwb`} {...stores}>
          <Router weId={`_dnd90w`}>
            {publicUrl && <>
              <Route weId={`_vt3a13`} exact path={`/`} render={() => (
                <Redirect weId={`_iyll7a`} to={`${publicUrl}/`} />
              )} />
            </>}
            <Route weId={`_mi2ki1`} path={publicUrl}>
              <Suspense weId={`_62asnj`} fallback={<Loading weId={`_a630o1`} />}>
                {isMobile() ? <MLoginPool weId={`_hpfuse`} /> : <RouteLoginPool weId={`_mb7t11`} />}
              </Suspense>
            </Route>
          </Router>
        </Provider>
      </React.StrictMode>,
      document.getElementById('root')
    );
  });
}
if (inApp() && isMobile()) {
  try {
    weappSDK.ready(() => {
      if (weappSDK.customSDK.checkJsApi('getNativeLanguageType')) {

        weappSDK.customSDK.invoke("getNativeLanguageType", {
          success: (res: any) => {
            // if (res) {
            //   toast({
            //     content: res.languageType
            //   })
            // }
            let languageType = res.languageType;
            if (languageType) {
              clearOneCookie('langType');
              let domain = window.location.hostname;
              if (domain.indexOf('passport') !== -1) {
                domain = domain.replace('passport', '');
              }
              if (languageType) {
                setCookie("langType", languageType, domain);
              }
            }
            initPage();
          }
        }).catch(() => {
          initPage();
        })
      } else {
        initPage();
      }
    })
  } catch (error) {
    initPage();
  }
} else {
  initPage();
}



// ReactDOM.render(
//   <Router weId={`p37d9s`}>
//     <CorsComponent weId="tpwtve" app="@weapp/designer-demo" compName="FlowDesignerDemo" />
//   </Router>,
//   document.getElementById('root'),
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

/*
 * 默认应用本身按照 lib.js 进行 ESmodule 规范导出
 * 应用本页如果需要在全局获取自身的库（二开之类），虽然一般用不到，将被封装到 default 导出，和 lib 之间有差异
*/
export default Lib;
